import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function QRAdmin() {
  const [units, setUnits] = useState([]);
  const [preview, setPreview] = useState(null);
  const load = useCallback(() => api.get("/admin/units").then((r) => setUnits(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (unit, status) => { await api.put(`/admin/units/${unit}/status?status=${status}`); toast.success("Updated"); load(); };

  return (
    <div>
      <h1 className="font-serif text-3xl mb-4">QR Authenticity</h1>
      <div className="grid md:grid-cols-4 gap-4 mb-6">
        <div className="admin-surface p-4"><p className="text-xs text-[#8C867D] uppercase tracking-widest">Total</p><p className="text-2xl font-serif">{units.length}</p></div>
        <div className="admin-surface p-4"><p className="text-xs text-[#8C867D] uppercase tracking-widest">Active</p><p className="text-2xl font-serif text-[#C5A059]">{units.filter(u => u.status === "active").length}</p></div>
        <div className="admin-surface p-4"><p className="text-xs text-[#8C867D] uppercase tracking-widest">Deactivated</p><p className="text-2xl font-serif">{units.filter(u => u.status !== "active").length}</p></div>
      </div>
      <div className="admin-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[#8C867D] text-xs uppercase tracking-widest text-left">
            <tr><th className="p-3">Unit ID</th><th>Product</th><th>Customer</th><th>Order</th><th>Status</th><th>QR</th></tr>
          </thead>
          <tbody>
            {units.map((u) => (
              <tr key={u.id} className="border-t border-[#27272A]">
                <td className="p-3 font-mono text-xs">{u.unit_id}</td>
                <td className="text-xs">{u.product_name}</td>
                <td className="text-xs">{u.customer_name || "—"}</td>
                <td className="font-mono text-xs">{u.order_number}</td>
                <td>
                  <select value={u.status} onChange={(e) => toggle(u.unit_id, e.target.value)} className="admin-input text-xs" data-testid={`admin-qr-status-${u.unit_id}`}>
                    <option value="active">Active</option>
                    <option value="deactivated">Deactivated</option>
                    <option value="flagged">Flagged</option>
                  </select>
                </td>
                <td><button onClick={() => setPreview(u)} className="text-xs uppercase tracking-widest text-[#C5A059]" data-testid={`admin-qr-view-${u.unit_id}`}>View</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {preview && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-6" onClick={() => setPreview(null)}>
          <div className="bg-[#18181B] p-8 max-w-md w-full text-center" onClick={(e) => e.stopPropagation()}>
            <img src={preview.qr_image} className="w-64 h-64 mx-auto" alt="QR" />
            <p className="mt-4 font-mono text-xs text-[#C5A059]">{preview.unit_id}</p>
            <p className="text-sm mt-2">{preview.product_name}</p>
            <a href={preview.verify_url} target="_blank" rel="noreferrer" className="text-[10px] underline text-[#8C867D] block mt-2 break-all">{preview.verify_url}</a>
            <a href={preview.qr_image} download={`${preview.unit_id}.png`} className="mt-4 inline-block bg-[#C5A059] text-[#121212] px-4 py-2 text-xs uppercase tracking-widest" data-testid="admin-qr-download">Download QR</a>
          </div>
        </div>
      )}
    </div>
  );
}
